import './index.css';
import registerServiceWorker from './registerServiceWorker';

import React from 'react';
import ReactDOM from 'react-dom';
import logger from 'redux-logger';

import 'react-dates/initialize';

// Redux Setup
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';

import createSagaMiddleware from 'redux-saga';

import { HashRouter, Route } from 'react-router-dom';

import createHistory from 'history/createHashHistory';

import rootReducer from './rootReducer.js';
import rootSaga from './rootSaga.js';

// Pages
import Header from './shared/components/Header';

import Home from './Home';

import { SET_ACCOUNT } from './Auth/actions';
import SignIn from './Auth/SignIn';

import GeofenceFindPOI from './Geofence/GeofenceFindPOI';
import GeofenceCreate from './Geofence/GeofenceCreate';

import POINetwork from './POI/POINetwork';

import LocationData from './Events/LocationData';

const history = createHistory();

// Redux and saga setup
const sagaMiddleware = createSagaMiddleware();
let store = createStore(rootReducer, applyMiddleware(logger, sagaMiddleware,routerMiddleware(history)));
sagaMiddleware.run(rootSaga);

const init = () => {
    store.dispatch({
        type: 'TESTING',
        payload: {
            message: 'Hello, World :)',
        }
    });
    const token = localStorage.getItem('token');

    try{
        const user = localStorage.getItem('user');
        if (user) {
            store.dispatch({
                type: SET_ACCOUNT,
                payload: JSON.parse(user),
            });
        }
    } catch(e){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        history.push('/auth/signin');
    }
    if (!token) {
        history.push('/auth/signin');
    }
    
}
init();

const Setup = () => (
	<Provider store={store}>
        <HashRouter>
            <div>
                <div>
                    <Header />
                </div>
                <div>
                    <Route path="/" component={Home} exact />
                    <Route path="/geofence/:geofence_id" component={GeofenceCreate} exact />
                    <Route path="/confirmGeofence" component={GeofenceFindPOI} exact />
                    <Route path="/poinetwork" component={POINetwork} exact />
                    <Route path="/events" component={LocationData} exact />

                    <Route path="/auth/signin" render={(() => {
                        const token = localStorage.getItem('token');
                        if (!token) {
                            return (<SignIn />);
                        } else {
                            history.push('/');
                            return null;
                        }
                    })} />
                </div>
            </div>
        </HashRouter>
    </Provider>
)

ReactDOM.render(<Setup />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js